import { call, put, takeLatest } from 'redux-saga/effects';

import * as digitalActions from './digitalActions.js';
import { updateDigitalApiCall } from './digitalAPI.js';

function* updateDigitalSaga({ payload }) {
  try {
    const { data } = yield call(updateDigitalApiCall, payload);
    yield put(digitalActions.digitalUpdateStore(data));
  } catch (error) {
    yield put(digitalActions.digitalUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* digitalWatcher() {
  yield takeLatest(digitalActions.digitalUpdateRequest.type, updateDigitalSaga);
}
